//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    selectList: {
      type: Array,
      default: () => []
    },
    selectTitle: {
      type: String
    },
    selectValue: {
      type: Number
    },
    clickElementClientY: {
      type: Number
    },
    itemStyle: {
      type: String
    }
  },
  data() {
    return {
      dialogCurrentTop: 300
    };
  },
  mounted() { },
  methods: {
    /** 关闭登陆弹窗 */
    dialogClose(event) {
      event.stopPropagation();
      event.preventDefault();
      this.$emit("getUnitDialogState", false);
    },
    changeValue(item) {
      this.$emit("setSelectValue", item);
      this.$emit("getUnitDialogState", false);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/formulaComponent/unitDialog.vue